import { useNavigate, useSearch } from '@tanstack/react-router';

const useSimplePagination = () => {
    const navigate = useNavigate();
    const { page } = useSearch({});

    const setPage = (newPage: number) => {
        navigate({ search: prev => ({ ...prev, page: newPage }) });
    };

    return {
        page,
        setPage,
        pageSize: 50,
    };
};

export default useSimplePagination;
